<template>
    <div>
        <span class="mr10">의뢰 양식 파일</span>
        <el-upload
            class="inline-block"
            action=""
            list-type="picture"
            :thumbnail-mode="true"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onlyOneFileUpload"
            v-if="files.length === 0 || !hasFile()"
        >
            <el-button class="com_btn">파일 업로드</el-button>
            <!--                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
        </el-upload>
        <div v-else class="inline-block">
            <span class="hover mr10" @click="runDownload()">{{ returnFileName() }}</span>
            <el-button class="com_del" @click="deleteFile()">파일 삭제</el-button>
        </div>

    </div>
</template>

<script>
import elFileMixins from "@/mixins/elFileMixins";
import util from "@/mixins/util";
import awsS3FileUpload from "@/mixins/awsS3FileUpload";
import EventBus from "@/utils/event-bus";
import {s3ApiDelete} from "@/plugins/awsS3Plugin";
import alertMixins from "@/mixins/alertMixins";
import awsS3FileDownload from "@/mixins/awsS3FileDownload";

export default {
    name: "ItemDetectionFileComponent",
    mixins: [elFileMixins, awsS3FileUpload,alertMixins, awsS3FileDownload],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            files: [],


        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.getFile()

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getFile() {
            let params = {
                cid: 1,
                cty: 'lawsuitSample',
            }
            this.$api.$file.getFile(params).then(res => res.Data.Result).then(res => {
                let sampleData = res.List
                this.files = sampleData
            })

        },
        returnFileName() {
            if (!util.isEmpty(this.files) && !util.isEmpty(this.files[0].org_name)) {
                return this.files[0].org_name
            } else if (!util.isEmpty(this.files) && !util.isEmpty(this.files[0].name)) {
                return this.files[0].name
            }
        },
        deleteFile() {
            this.createConfirm({
                content : '파일을 삭제하시겠습니까?',
                confirm:()=>{
                    this.deleteFiles = this.files
                    this.files = []
                    this.runS3ApiDelete(this.deleteFiles,0)
                },
            })
        },
        runS3ApiDelete(deleteFiles, index = 0) {
            //파일에서 a_idx만 추출하여 리스트화
            let deleteFileIdx = []

            deleteFiles.forEach(v => {
                if (v.hasOwnProperty('a_idx') && !util.isEmpty(v.a_idx)) {
                    deleteFileIdx.push(v.a_idx)
                }
            })
            let _this = this

            //삭제하고자 하는 파일의 갯수만큼 반복
            let a_idx = deleteFileIdx[index]
            if (index < deleteFileIdx.length) {
                s3ApiDelete(a_idx).then(res => {
                    if (res.Info.type == 1) {
                        _this.runS3ApiDelete(deleteFiles, index + 1)
                    } else {
                        _this.errorAlert('파일 삭제에 실패하였습니다.')
                    }
                })
            } else {
                _this.createAlert({content:'파일이 삭제되었습니다.'})
            }
        },
        runDownload() {
            console.log('test')
            // todo : 다운로드
            if(util.isEmpty(this.files[0].a_idx)) {
                return false;
            }
            this.runDownloadFileInfo('lawsuitSample', this.files[0], 1).then(res => {
                if (!res) {
                    this.errorAlert('파일 다운로드에 실패했습니다.');
                }
            })
        },
        onlyOneFileUpload(file, fileList) {
            if (fileList.length > 1) {
                this.errorAlert('하나의 파일만 첨부가능합니다.');
                fileList.pop();
                return false
            }
            let maxSize = this.imageMaxSize;
            let type = file.raw.type.split('/');
            file.name = this.regExp(file.name)
            if (file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 ' + maxSize + '를 초과했습니다!');
                fileList.pop();
            } else if (!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            } else {
                // file.type = type
                file.org_url = file.url;
                if (this.files.length > 0 && this.files[0].hasOwnProperty('a_idx') && this.files[0].a_idx != null) {
                    file.a_idx = this.files[0].a_idx;
                }
                this.files[0] = file;
                this.$forceUpdate();
                if (this.parentChange) {
                    this.parentChange('files', this.files);
                }
                this.uploadFile()
            }
        },
        uploadFile() {
            EventBus.$emit('changeLoading', true)
            let fileInfo = [
                {
                    fileName: 'files',
                    fileType: 'lawsuitSample',
                },
            ]
            this.runUploadFileInfo(fileInfo, 0, 1).then(res=>{
                if(res){
                    this.getFile()
                    this.createAlert({
                        content : '파일이 등록되었습니다.'
                    })
                }
            })
        },
        hasFile(){
            return  !util.isEmpty(this.files) && !util.isEmpty(this.files[0].a_idx)
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
